import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { useSelector } from 'react-redux';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_LOAD_STRIPE_KEY);

const Stripe = ({ payNowClose }) => {
    const [message, setMessage] = useState(null);
    const clientSecret = useSelector((state) => state.strpie.clientSecret)

    const appearance = {
        theme: 'stripe',
    };
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <div className="payNow_stripe" style={message ? {maxHeight:'665px'} : {maxHeight: '616px'}}>
            {clientSecret && (
                <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm
                        payNowClose={payNowClose}
                        message={message}
                        setMessage={setMessage}
                    />
                </Elements>
            )}
        </div>
    );
}

export default Stripe;